import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  Tag
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        border: '1px solid #e5e7eb',
        minWidth: '280px',
        maxWidth: '320px',
        position: 'relative'
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />

      {/* Botões de ação */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 12,
          top: 12,
          cursor: "pointer",
          gap: 8
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#3b82f6' } }}
        />

        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>

      {/* Header com ícone e título */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <Tag
          sx={{
            width: "18px",
            height: "18px",
            color: "#3b82f6"
          }}
        />
        <div style={{
          color: "#111827",
          fontSize: "14px",
          fontWeight: 600
        }}>
          Tag
        </div>
      </div>

      {/* Nome da tag */}
      <div style={{
        color: "#6b7280",
        fontSize: "12px",
        lineHeight: '1.5'
      }}>
        {data.tag?.name || 'Tag'}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
